import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { commonFunctionService } from './utils/commonFunctions';
import *  as loginStrings from "./stringFiles/newLogin.json";
import { Router } from '@angular/router';
import * as serverDownStrings from "./stringFiles/serverDown.json"
declare var $: any;
declare var customToastr: any;
@Injectable()
export class serviceInterceptor implements HttpInterceptor {

  loginStrings: any = loginStrings;
  serverDownStrings: any = serverDownStrings;
  constructor(private commonFunction: commonFunctionService, private router: Router) {
    this.initScript()
  }
  counter = 0;
  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function (message,type){toastr.options.hideDuration = 0;toastr.remove();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false; toastr.options.preventDuplicates = true;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // localStorage.removeItem(this.serverDownStrings.serverDown)
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error && error.error && error.error.status_code === 401) {
          this.clearSessionStorage();
          this.deleteCookiesBasedOnURL();
          this.router.navigate(["/login"])
        }
        // else if (error && (error.status === 0 || error.statusText == "Unknown Error")) {
        //   localStorage.setItem(this.serverDownStrings.serverDown, this.serverDownStrings.serverDownText)
        //   this.router.navigate(["server/down"]);
        // }
        return throwError(() => error);
      }),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.body && (event.body.errorcode == this.loginStrings.sessionErrorCode || event.body.msg === this.loginStrings.pleaseLogin)) {
            this.clearSessionStorage();
            this.deleteCookiesBasedOnURL();
            this.router.navigate(["/login"]);
            this.counter++;
            if (this.counter <= 1) {
              customToastr(this.loginStrings.SessionExpiredMessage, this.loginStrings.error);
            }
          }
        }
      })
    );
  }

  // Preserve the chosen display language across a forced session-expiry
  // logout — it's a device/browser preference, not part of the session.
  clearSessionStorage() {
    const savedLang = localStorage.getItem('lang');
    localStorage.clear();
    if (savedLang) {
      localStorage.setItem('lang', savedLang);
    }
  }

  deleteCookiesBasedOnURL() {
    if (window.location.hostname.split('.')[1] === this.loginStrings.localhost) {
      this.commonFunction.deleteAllLocalCookies();
    } else {
      this.commonFunction.deleteAllCookies();
    }
  }
}